import { Tooltip, Typography } from 'antd';
import { Avatar } from 'components/common';
import { OmiChanelChatSourceIcon } from 'components/omni-channel-chat';
import dayjs from 'dayjs';
import { useChatStatusLabel } from 'hooks';
import { aiAgentCenterMessages, messages } from 'messages';
import React, { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto, UserCompactDto } from 'types';

type AIChatItemProps = {
  item: ChatSessionDto;
  selected?: boolean;
  onSelect?: () => void;
  monitoringUsers?: UserCompactDto[];
};

// Helper chuyển hex (#RRGGBB) sang rgba với alpha; nếu không đúng định dạng hex trả về màu gốc.

const AIChatItem: React.FC<AIChatItemProps> = ({ item, selected, onSelect, monitoringUsers }) => {
  const chatAction = item.lastAiAction?.content ?? aiAgentCenterMessages.supporting;

  return (
    <div
      className={twMerge(
        'flex w-full cursor-pointer gap-4 px-5 py-3 hover:bg-colorBgItemHover',
        selected && 'bg-colorBgItemHover'
      )}
      onClick={onSelect}
    >
      <div>
        <div className='relative h-12 w-12 rounded-full'>
          <Avatar key={item.chatSessionId} size={48} src={item.chat.customerAvatar} name={item.chat.customerName} />
          <div className='absolute -bottom-1 right-0 h-5 w-5'>
            <OmiChanelChatSourceIcon size={20} source={item.chat.source} />
          </div>
        </div>
      </div>
      <div className='mt-[3px] flex flex-1 flex-col gap-1'>
        <Typography.Text className='font-semibold leading-5'>{item.chat.customerName}</Typography.Text>
        <Typography.Paragraph className='mb-0 text-sm text-colorTextPlaceholder'>{chatAction}</Typography.Paragraph>
      </div>
      <div className='mt-[3px] flex flex-col items-end'>
        <Typography.Text className='text-end text-xs text-colorTextPlaceholder'>
          {messages.from} {dayjs(item.processingAt).format('HH:mm')}
        </Typography.Text>
        {monitoringUsers?.length ? (
          <div className='mt-0.5 flex items-center justify-end'>
            {monitoringUsers.map((user, i: number) => (
              <div key={user.userId} className={twMerge(i !== 0 && '-ml-2', 'h-6 w-6 rounded-full')}>
                <UserAvatar avatar={user.avatar} name={user.fullName} />
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const UserAvatar: React.FC<{ avatar?: number; name: string }> = ({ avatar, name }) => {
  return (
    <Tooltip
      prefixCls='avatar-tooltip'
      title={
        <div className='flex items-center gap-2 px-[2px]'>
          <Avatar className='border-white' size={32} fileId={avatar} name={name} />
          <Typography.Text className='text-sm text-white'>{name}</Typography.Text>
        </div>
      }
      placement='top'
    >
      <Avatar className='border-white' size={24} fileId={avatar} name={name} />
    </Tooltip>
  );
};

export default memo(AIChatItem);
